// import logo from './Penta-Logo-02.png';
import './Spinner.css';

function Spinner() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={localStorage.getItem("theme")==="light"?"/assets/images/Penta-Logo-02.png":"https://appcdn.goqii.com/storeimg/47811_1676009338.png"} className="App-logo" alt="logo" style={{height:"60px"}}/>
      </header>
    </div>
  );
}

export default Spinner;